import { render, staticRenderFns } from "./website-whois.vue?vue&type=template&id=3c3e9f72&scoped=true&"
import script from "./website-whois.vue?vue&type=script&lang=js&"
export * from "./website-whois.vue?vue&type=script&lang=js&"
import style0 from "./website-whois.vue?vue&type=style&index=0&id=3c3e9f72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3e9f72",
  null
  
)

export default component.exports